module.exports = __webpack_public_path__ + "img/skip-back.7921e4d8.svg";